export default __webpack_public_path__ + "static/media/learning-and-iterating.0f0a58b3.svg";